import { postRequest } from "./axiosAction";
import { getApiParam } from "./params";

// OFCダッシュボードのAPI呼び出し
export const apiRequest = async (params: any) => {
  const graphql_api_url: string = process.env.REACT_APP_OFC_DASHBOARD_GRAPHQL! + "/graphql";
  let res: any = {};
  try {
    res = await postRequest(graphql_api_url, getApiParam(params));
  } catch (error) {
    console.log("error", error);
    throw error;
  }
  return res;
};
